import React from "react";
import "../Contact/Contact.css";
import Contactmain from "./Contactmain";

const Contact = () => {
  return (
    <>
      <div className="about-us">
        <div className="overlay-a">
          <div className="text-container">
            <h1>Get in Touch with Packaging Experts</h1>
            <p>
              Whether you need customized solutions or expert advice, we're here
              to support your orthopedic packaging needs with precision and
              care.
            </p>
          </div>
        </div>
        <img
          src="/cont.webp" // Replace with your image URL
          alt="Contact Us Poster"
          className="poster-image"
        />
      </div>
      <Contactmain />
    </>
  );
};

export default Contact;
